// VulnerabilityPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header'; // Import Header component
import Footer from '../components/Footer'; // Import Footer component
import Banner from '../components/Banner'; // Import Banner component
import InfoBanner from '../components/InfoBanner';
import { useParams } from 'react-router-dom';
import PageNotFound from '../pages/PageNotFound'; // Import the PageNotFound component
import Accordion from '../components/Accordion';


import { appUrl } from '../properties/properties';

const VulnerabilityPage = () => {
  const { id } = useParams();
  const [vulnerability, setVulnerability] = useState(null);
  const [isIDActive, setIDActive] = useState(null);

  const [notFound, setNotFound] = useState(false); // State to track if the page is not found

  useEffect(() => {
    const fetchVulnerability = async () => {
      try {
        const response = await fetch(`${appUrl}/advisory?id=${id}`);
        // 404 since ENISASUP-924; 204 is what the API sent before, kept so this page
        // works whichever of the two is deployed first.
        if (response.status === 404 || response.status === 204) {
          setNotFound(true);
        } else if (!response.ok) {
          // An error body is not an advisory; rendering it as one crashes the page.
          throw new Error(`Unexpected status ${response.status}`);
        } else {
          const data = await response.json();
          setVulnerability(data);
        }
      } catch (error) {
        console.error('Error fetching advisory details:', error);
      }
    };

    fetchVulnerability();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Return empty string if date string is empty
    const date = new Date(dateString);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    let day = date.getDate();
    day = day < 10 ? `0${day}` : day;

    let hour = date.getHours();
    hour = hour < 10 ? `0${hour}` : hour;
    let minute = date.getMinutes();
    minute = minute < 10 ? `0${minute}` : minute;

    return `${year}-${month}-${day} ${hour}:${minute}`;
  };

  const renderReferences = () => {
    const references = vulnerability.references.split('\n');
    return references.map((reference, index) => (
      <li key={index}>
        <a href={reference} target="_blank" rel="noopener">{reference}</a>
      </li>
    ));
  };

  const renderProducts = () => {
    return vulnerability.advisoryProduct.map((product) => (
      <li key={product.id}>{product.product.name}</li>
    ));
  };
  
  const renderProductsVersion = () => {
    return vulnerability.enisaIdProduct.map((product) => (
      <li key={product.id}>{product.product_version && `(${product.product_version})`}</li>
    ));
  };

  const renderVendors = () => {
    const uniqueVendors = vulnerability.advisoryProduct.reduce((vendors, product) => {
      const vendorName = product.product.vendor.name;
      if (!vendors.includes(vendorName)) {
        vendors.push(vendorName);
      }
      return vendors;
    }, []);

    return uniqueVendors.map((vendorName, index) => (
      <li key={index}>{vendorName}</li>
    ));
  };

  useEffect(() => {
      if (vulnerability) {
        document.title = `${vulnerability.id} | EUVD`;
      } else {
        document.title = "EUVD";
      }
    }, [vulnerability]);

  return (
    <>
      <Header />
      <InfoBanner />
      {notFound ? (
        <PageNotFound />
      ) : (
        vulnerability && (
        <main>

            <section className="banner">
               <nav className="breadcrumbs container-1200">
                <ul>
                  <li><a href="/homepage">Home</a></li>
                  <li><a href="/search">Vulnerability List</a></li>
                  <li><a href="">{vulnerability.id}</a></li>
                </ul>
              </nav>
            </section>          

          <div className="container-1200 container-up" id='advisoryDetailPage'>
            <h1 className="hidden">ENISA Vulnerability Database</h1>

              <div className="title-wrapper">
                <div className='id-wrapper'>
                  <h2>{vulnerability.id}</h2>
                  {vulnerability.assigner && (
                    <p className="label csirt">Vulnerability from: <span>{vulnerability.assigner}</span></p>
                  )}
                </div>
                
                <a className="btn-primary back" href="/search">Back to the vulnerability search</a>
              </div>
              <section className='vulnerability-information-wrapper'>
                    <div className="info">
                        {vulnerability.datePublished && (
                          <p className="label published">Published: <span>{formatDate(vulnerability.datePublished)}</span></p>
                        )}
                        {vulnerability.dateUpdated && (
                          <p className="label updated">Updated: <span>{formatDate(vulnerability.dateUpdated)}</span></p>
                        )}
                        {vulnerability.description && (
                          <p className="label updated">Title: <span>{vulnerability.description}</span></p>
                        )}

                    </div>
                    <div className=' info infoTwo'>
                      {vulnerability.aliases && (
                        <p className="label alias">Alias: <span>{vulnerability.aliases}</span></p>
                      )}
                      {vulnerability.summary && (
                         <>
                            <p className="label">Summary:</p>
                            <p><span>{vulnerability.summary}</span></p>
                          </>
                      )}
                     
                    </div>
              </section>
              <div>
                             
              <section className="related-vulnerabilities-accordion-wrapper">
                <h3 className="underlined-title">Related Vulnerabilities <span className='counter'>{}</span> </h3>
                  <ol>

                    {/**vulnerability.enisaIdAdvisories*/}
                    {vulnerability.enisaIdAdvisories.map((item, index) => (  
                      <li> 
                        <Accordion item={item} isIDActive={isIDActive} setIDActive={setIDActive}></Accordion>
                      </li>
                    ))}
                  </ol>
              </section>             
            </div>
          </div>
          <Banner />
        </main>
        )
      )}
      <Footer />
    </>
  );
};

export default VulnerabilityPage;

